import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetPunchoutUserIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";
import PunchoutUserIdentityPageState from "@TKCCP/Store/Pages/PunchoutUserIdentity/PunchoutUserIdentityState";
import { Draft } from "immer";

const initialState: PunchoutUserIdentityPageState = {
    getPunchoutParameter: {
        userId: "",
        // sort: "Identity desc",
    },
    isFilterOpen: false,
};

const reducer = {
    "Pages/PunchoutUserIdentity/UpdateSearchFields": (
        draft: Draft<PunchoutUserIdentityPageState>,
        action: { parameter: GetPunchoutUserIdentityApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getPunchoutParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getPunchoutParameter = { ...initialState.getPunchoutParameter, ...action.parameter };
        } else {
            draft.getPunchoutParameter = { ...draft.getPunchoutParameter, ...action.parameter };

            for (const key in draft.getPunchoutParameter) {
                const value = (<any>draft.getPunchoutParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getPunchoutParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getPunchoutParameter.page &&
                    draft.getPunchoutParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getPunchoutParameter.page = 1;
                }
            }
        }
    },
    "Pages/PunchoutUserIdentity/ClearParameter": (draft: Draft<PunchoutUserIdentityPageState>) => {
        draft.getPunchoutParameter = {
            ...initialState.getPunchoutParameter,
            pageSize: draft.getPunchoutParameter.pageSize,
        };
    },
    "Pages/PunchoutUserIdentity/ToggleFiltersOpen": (draft: Draft<PunchoutUserIdentityPageState>) => {
        draft.isFilterOpen = !draft.isFilterOpen;
    },
};

const punchoutUserIdentityPageReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).pagePunchoutUserIdentity = punchoutUserIdentityPageReducer;
